// extracted by mini-css-extract-plugin
export default {"form":"ImportFile_form__bu3JM","content":"ImportFile_content__RYTNO","submit":"ImportFile_submit__VPBl2"};